<template>
  <div class="callout" :class="[{ 'is-active' : expanded }, { 'hide-arrow' : arrow === false}, { 'is-left' : anchored == 'left' }, { 'is-right': anchored == 'right' }]">
    <slot><!-- Callout content --></slot>
  </div>
</template>

<script>
export default {
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    anchored: {
      type: String,
      default: 'left',
      validator(val) {
        return ['left', 'right'].includes(val);
      },
    },
    arrow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

$chevron-size: 6px;

.callout {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  color: $darkBlack;
  background-color: $stoneWhite;
  box-shadow: 0 1px 3px rgba($black, 0.1);
  z-index: 1;

  &.is-active {
    &.hide-arrow:after {
      content: none;
    }
  }
  @include dropdown(-4px);
  &:after {
    position: absolute;
    top: -($chevron-size);
    pointer-events: none;
    @include triangle($chevron-size, white, up);
  }
  &.is-left:after {
    left: 55px;
  }
  &.is-right:after {
    right: $chevron-size * 3 + 2;

    @media screen and (min-width : 360px) and (max-width : 599px) {
      right: 66px;
    }

    @media screen and (max-width: 320px) {
      right: 30px;
    }
  }
}
</style>
